import KeenSlider from 'keen-slider';

class Slider {
	constructor(selector, origOpts = {}) {
		
		this.selector = selector;
		this.$element = $(selector);
		this.$slides = this.$element.find('.keen-slider__slide');
		this.$pager = this.$element.siblings('.keen-slider__pager');
		this.$arrows = this.$element.siblings('.keen-slider__arrows');
		this.$count = this.$arrows.find('.keen-slider__count');

		this.origOpts = origOpts;
		if ( this.origOpts.fade ) {
			this.origOpts.slides = this.$slides.length;
			this.$element.addClass('keen-slider__fade');
		}
		this.opts = Object.assign({}, origOpts);
		this._autoplay = {
			hoverPause: false,
			dragPause: false
		};
		this.opts.created = (instance) => {
			this.opts.autoplay && this.registerAutoplay();
			this.registerArrows();
			this.updateArrows(instance);
			this.opts.pager && this.registerPager();
			this.registerCount();
			this.updateCount(instance);
			this.origOpts.created && this.origOpts.created();
			this.$element.addClass('keen-slider__created');
			this.$pager.addClass('keen-slider__created');
		};
		// fires whenever a matching breakpoint changes (e.g. resize past lg) -
		// keen-slider re-resolves instance.options from whichever breakpoint
		// now wins, so re-reading opts.arrows from there each time is what
		// makes arrow visibility react live instead of being fixed at
		// whatever it was on first paint.
		this.opts.optionsChanged = (instance) => {
			this.updateArrows(instance);
			this.updateCount(instance);
			this.origOpts.optionsChanged && this.origOpts.optionsChanged();
		};
		this.opts.dragStart = () => {
			this._autoplay.dragPause = true;
			this._tryAutoplay();
			this.origOpts.dragStart && this.origOpts.dragStart();
		};
		this.opts.dragEnd = () => {
			this._autoplay.dragPause = false;
			this._tryAutoplay();
			this.origOpts.dragEnd && this.origOpts.dragEnd();
		};
		this.opts.slideChanged = () => {
			setTimeout(() => {
				let activeIndex = this.instance.track.details.rel || 0;
				this.$slides.each((index, slide) => {
					let $slide = $(slide);
					$slide.toggleClass('active', index == activeIndex);
					// auto ajax load prev & next slides if applicable
					if ( index == activeIndex ) {
						$slide.next().add($slide.prev()).each(function () {
							let $slide = $(this);
							let bg = $slide.attr('data-background-image');
							bg && $slide.css('background-image', `url("${bg}")`);
						});
					}
				});
				this.$pager.length && this.$pager.find('button').each((index, btn) => {
					$(btn).toggleClass('active', index == activeIndex);
				});
				this.$count.find('.keen-slider__count-current').text(activeIndex + 1);
				this._tryAutoplay();
				this.origOpts.slideChanged && this.origOpts.slideChanged();
			});
		};
		this.instance = new KeenSlider(this.$element[0], this.opts);
	}
	registerArrows() {
		this.$arrows.on('click', '[data-dir]', e => {
			e.preventDefault();
			this.instance[e.currentTarget.getAttribute('data-dir')]();
		});
	}
	updateArrows(instance) {
		this.$arrows.toggleClass('d-none', ! instance.options.arrows);
	}
	// strict === false, not a plain truthy check - callers that never set a
	// `counter` option (e.g. list_content.blade.php) keep the counter always
	// on, same as before this existed; only an explicit false hides it.
	updateCount(instance) {
		this.$count.toggleClass('d-none', instance.options.counter === false);
	}
	registerPager() {
		if ( this.$pager.length ) {
			//console.log(this.opts.slides.perView);
			//console.log(this.$slides.length);
			//console.log(this.$slides.length/Math.round(this.opts.slides.perView));
			//console.log(Math.round(this.$slides.length/this.opts.slides.perView));

			/*if(this.opts.slides.perView >= 2) {
				let html = '';
				for (let i = 0; i < this.$slides.length; i++) {
					if(i == 0 || i%Math.round(this.opts.slides.perView) == 0) {
						console.log(i);
						html += `<button type="button" data-slide="${i}" class="${ i == 0 ? 'active' : '' }"></button>`;
					}
				}
				this.$pager.find('.keen-slider__pager-buttons').html(html);
			} else {
			}*/
			this.$pager.find('.keen-slider__pager-buttons').html($.map(this.$slides, function (slide, i) {
				return `<button type="button" data-slide="${i}" class="${ i == 0 ? 'active' : '' }"></button>`;
			}).join(''));

			this.$element.addClass('keen-slider__hasPager');
			this.$pager.on('click', '[data-slide]', e => {
				e.preventDefault();
				this.instance.moveToIdx(parseInt(e.currentTarget.getAttribute('data-slide')));
			});
		}
		
	}
	registerCount() {
		this.$count.find('.keen-slider__count-total').text(this.$slides.length);
		this.$count.find('.keen-slider__count-current').text(1);
	}
	registerAutoplay() {
		if ( this.opts.pauseOnHover ) {
			this.$element.on('mouseenter', () => {
				this._autoplay.hoverPause = true;
				this._tryAutoplay();
			});
			this.$element.on('mouseleave', () => {
				this._autoplay.hoverPause = false;
				this._tryAutoplay();
			});
		}
		this._tryAutoplay();
	}
	_tryAutoplay() {
		if ( this.opts.autoplay ) {
			clearTimeout(this._autoplay.timeout);
			this._autoplay.timeout = setTimeout(() => {
				if ( !(this._autoplay.dragPause || this._autoplay.hoverPause) ) {
					this.instance.next();
				}
			}, this.opts.autoplay);
		}
	}
}

export default Slider;